import {Button, Modal} from "semantic-ui-react";
import React from "react";

export function DeleteConfirmationModal(props: { open: boolean, onClose: () => void, onClick: () => void }) {
    return <Modal open={props.open} onClose={props.onClose} size="small">
        <Modal.Header>Delete Survey Schedule</Modal.Header>
        <Modal.Content>
            <p>Are you sure you want to delete this survey schedule?</p>
        </Modal.Content>
        <Modal.Actions>
            <Button onClick={props.onClose}>Cancel</Button>
            <Button color="red" onClick={props.onClick}>
                Delete
            </Button>
        </Modal.Actions>
    </Modal>
}